import { DialogCustomArticleAdd } from "@bundles/compilations/components/compilations/OwnArticles/ArticleEditDialog"
import { AddCustomArticleItemsRequest, useAddCustomArticleItem } from "@tm/data/basket"
import { Note, NoteTypes } from "@tm/models"
import { useSaveNote } from "@tm/utils"
import { useCallback } from "react"

type OwnArticleRequest = Omit<DialogCustomArticleAdd, "type">

export const useSaveOwnArticle = () => {
    const { saveNote } = useSaveNote()
    const { mutateAsync: saveNewCustomArticle } = useAddCustomArticleItem()

    return useCallback(
        async (articleRequest: OwnArticleRequest, note?: string) => {
            try {
                if (articleRequest.description) {
                    const request: AddCustomArticleItemsRequest = {
                        customArticleItemsToAdd: [articleRequest],
                    }

                    const result = await saveNewCustomArticle(request)

                    if (note && result?.addedCustomArticleItems.length === 1) {
                        const addedCustomArticle = result.addedCustomArticleItems[0]

                        const noteRequest: Note = {
                            type: NoteTypes.CUSTOM_ARTICLE,
                            text: note,
                            noteId: addedCustomArticle.id,
                        }

                        await saveNote(noteRequest)
                    }
                }

                return true
            } catch {
                return false
            }
        },
        [saveNewCustomArticle, saveNote]
    )
}
